import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import SectorsSection from './components/SectorsSection';
import WhyUsSection from './components/WhyUsSection';
import ContactSection from './components/ContactSection';
import FooterSection from './components/FooterSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaOrg = [
  {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    '@id': `${SITE_URL}/#localbusiness`,
    name: 'GLOBAL ENERGY SRL',
    legalName: 'GLOBAL ENERGY SRL',
    description:
      'GLOBAL ENERGY SRL è una società con sede ad Arezzo attiva da oltre dieci anni nel settore edile e nel comparto dei materiali e delle soluzioni orientate al risparmio energetico, pannelli fotovoltaici e strutture in ferro.',
    url: SITE_URL,
    logo: 'https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/fa617871f52148f2c372440aa483fbed.png',
    image: 'https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/fa617871f52148f2c372440aa483fbed.png',
    telephone: '',
    email: 'info.globalenergysrl@gmail.com',
    vatID: 'IT-02198440519',
    foundingDate: '2014',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Via Don Luigi Sturzo 181',
      addressLocality: 'Arezzo',
      postalCode: '52100',
      addressRegion: 'AR',
      addressCountry: 'IT',
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 43.4632,
      longitude: 11.8796,
    },
    areaServed: {
      '@type': 'Country',
      name: 'Italia',
    },
    hasMap: 'https://maps.google.com/?q=Via+Don+Luigi+Sturzo+181,+52100+Arezzo+AR',
    sameAs: [],
    priceRange: '€€',
    currenciesAccepted: 'EUR',
    paymentAccepted: 'Bonifico bancario, Contanti',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '08:00',
        closes: '18:00',
      },
    ],
    knowsAbout: [
      'Risparmio energetico',
      'Pannelli fotovoltaici',
      'Energie rinnovabili',
      'Strutture in ferro',
      'Forniture industriali',
      'Edilizia',
    ],
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': `${SITE_URL}/#organization`,
    name: 'GLOBAL ENERGY SRL',
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: 'https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/fa617871f52148f2c372440aa483fbed.png',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'info.globalenergysrl@gmail.com',
      contactType: 'customer service',
      availableLanguage: 'Italian',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    '@id': `${SITE_URL}/#website`,
    url: SITE_URL,
    name: 'GLOBAL ENERGY SRL',
    description:
      'Soluzioni per il risparmio energetico, pannelli fotovoltaici e strutture in ferro ad Arezzo.',
    inLanguage: 'it-IT',
    publisher: {
      '@id': `${SITE_URL}/#organization`,
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE_URL}/#webpage`,
    url: SITE_URL,
    name: 'GLOBAL ENERGY SRL Arezzo - Risparmio Energetico & Pannelli Fotovoltaici',
    description:
      'GLOBAL ENERGY SRL ad Arezzo: oltre 10 anni di esperienza in risparmio energetico, pannelli fotovoltaici, energie rinnovabili e strutture in ferro.',
    inLanguage: 'it-IT',
    isPartOf: { '@id': `${SITE_URL}/#website` },
    about: { '@id': `${SITE_URL}/#localbusiness` },
    dateModified: '2026-04-04',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Cosa fa GLOBAL ENERGY SRL?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'GLOBAL ENERGY SRL è specializzata in soluzioni per il risparmio energetico, pannelli fotovoltaici, energie rinnovabili, strutture in ferro e forniture per il settore edile e industriale.',
        },
      },
      {
        '@type': 'Question',
        name: 'Dove si trova GLOBAL ENERGY SRL?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'La sede di GLOBAL ENERGY SRL si trova in Via Don Luigi Sturzo 181, 52100 Arezzo (AR), Italia.',
        },
      },
      {
        '@type': 'Question',
        name: 'Da quanti anni opera GLOBAL ENERGY SRL?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'GLOBAL ENERGY SRL opera da oltre dieci anni nel settore edile e nel comparto del risparmio energetico e delle energie rinnovabili.',
        },
      },
      {
        '@type': 'Question',
        name: 'Come contattare GLOBAL ENERGY SRL?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Puoi contattare GLOBAL ENERGY SRL via email all\'indirizzo info.globalenergysrl@gmail.com oppure visitando la sede in Via Don Luigi Sturzo 181, 52100 Arezzo.',
        },
      },
    ],
  },
];

export default function HomePage() {
  useEffect(() => {
    const existingScripts = document.querySelectorAll('script[data-schema="global-energy"]');
    existingScripts.forEach((s) => s.remove());

    schemaOrg.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'global-energy');
      script.setAttribute('data-schema-index', String(index));
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    });

    return () => {
      const scripts = document.querySelectorAll('script[data-schema="global-energy"]');
      scripts.forEach((s) => s.remove());
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <SectorsSection />
      <WhyUsSection />
      <ContactSection />
      <FooterSection />
    </div>
  );
}
